import { BitrixVue } from "ui.vue";
BitrixVue.cloneComponent("Step8", "Steps", {
  data() {
    return {
      activeElement: 0,
      activeElement2: null,
      selectedLatchValue: 0,
      selectedLatchZavertkaValue: null,
      selectedLatchVrezkaValue: null,
      showStep: false,
      radio1: [
        { label: "Под фиксатор", value: 0 },
        { label: "Под цилиндр", value: 1 },
      ],
      radio2: [
        { label: "Да", text: "+300 руб", value: 1, price: 300 },
        { label: "Нет", value: 0, price: 0 },
      ],
      radio3: [
        { label: "Да", value: 1 },
        { label: "Нет", value: 0 },
      ],
      latchCilinder: [],
      latchRetainer: [],
    };
  },
  props: ["_handleDesign", "handleDesignColor"],
  created() {
    this.getDataStep();
    this.setPropPosition({
      latchValue: this.radio1[0],
      latchVrezkaValue: this.radio2[1],
      latchZavertkaValue: this.radio3[1],
    });
  },
  watch: {
    _handleDesign: function (val) {
      this.setFirstPoints();
    },

    handleDesignColor: function (val) {
      this.getDataStep();
      this.setPropPosition({
        latchValue: this.radio1[0],
        latchVrezkaValue: this.radio2[1],
        latchZavertkaValue: this.radio3[1],
      });
    },

    activeElement2: function (val) {
      this.setPropPosition({ latchZavertkaModel: this.step8.zavertka[val] });
    },
  },
  methods: {
    isDataStep: function () {
      return this.step8;
    },
    setActiveLatch(index) {
      this.activeElement = index;
      let activeElementData = [];
      if (
        this.radio1[this.selectedLatchValue].label.trim().toLowerCase() ===
        "под цилиндр"
      ) {
        activeElementData = this.latchCilinder[this.activeElement];
      } else if (
        this.radio1[this.selectedLatchValue].label.trim().toLowerCase() ===
        "под фиксатор"
      ) {
        activeElementData = this.latchRetainer[this.activeElement];
      }
      this.setPropPosition({
        latchModel: activeElementData,
      });
    },
    setFirstPoints() {
      this.selectedLatchValue = 0;
      let activeElementData = [];
      if (
        this.radio1[this.selectedLatchValue].label.trim().toLowerCase() ===
        "под цилиндр"
      ) {
        activeElementData = this.latchCilinder[this.activeElement];
      } else if (
        this.radio1[this.selectedLatchValue].label.trim().toLowerCase() ===
        "под фиксатор"
      ) {
        activeElementData = this.latchRetainer[this.activeElement];
      }
      this.setPropPosition({
        latchModel: activeElementData,
      });
    },
    getDataStep: function () {
      let context = this;

      let store = { ...this.$store.state.position };
      delete store.renderImage;

      let req = BX.ajax.runComponentAction(
        "mworks:configurator",
        "getDataStep8",
        {
          mode: "class",
          method: "post",
          data: {
            position: store,
          },
        }
      );

      req.catch(function (response) {});

      req.then((response) => {
        if (response.status == "success") {
          context.step8 = response.data.result;
          const latchType = this.radio1.filter((item) => {
            if (this.selectedLatchValue === item.value) return item;
          });

          if (latchType.length) {
            context.setPropPosition({
              latchType: latchType[0],
            });
          }

          if (context.step8.lathes.length) {
            context.showStep = true;
            context.latchCilinder = context.step8.lathes.filter((item) => {
              if (item.type.trim().toLowerCase() === "под цилиндр") return item;
            });
            context.latchRetainer = context.step8.lathes.filter((item) => {
              if (item.type.trim().toLowerCase() === "под фиксатор")
                return item;
            });

            context.setPropPosition({
              latchModel: context.latchCilinder[context.activeElement],
            });
          } else {
            context.showStep = false;
          }
        }
      });
    },
    selectedLatch(value) {
      this.selectedLatchValue = value;
      this.setPropPosition({
        latchType: this.radio1.filter((item) => {
          if (value === item.value) return item;
        })[0],
      });
      this.setActiveLatch(0);
    },
    selectedLatchVrezka(value) {
      this.selectedLatchVrezkaValue = value;
      this.radio2.forEach((item) => {
        if (item.value === value)
          this.setPropPosition({ latchVrezkaNeeding: item });
      });
    },
    selectedLatchZavertka(value) {
      this.selectedLatchZavertkaValue = value;
      this.setPropPosition({
        latchZavertkaNeeding: this.radio3.filter((item) => {
          if (value === item.value) return item;
        })[0],
      });

      if (!value || value == 0) {
        this.deletePositionKey(["latchZavertkaModel"]);
        this.activeElement2 = null;
      }
    },
  },
  template: `
<div class="config-block">
	<div class="config-block__inner" v-if="showStep">
		<div class="config-block__wrap">
			<div class="config-block__wrap-title">Тип защелки</div>
			<RadioGroup :options="radio1" :selected="radio1[selectedLatchValue]" name="latch_type" v-on:selectedValue="selectedLatch" />
		</div>
		<div class="config-block__wrap mt-48" v-if="(radio1[selectedLatchValue].label==='Под фиксатор')">
			<div class="config-block__wrap-title">Модель защелки</div>
			<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
				<div class="swiper-slide" v-for="(slide, index) of latchRetainer">
					<SimpleItem :image="slide.image" :price="slide.price" :priceType="2" :key="index"
						:class="{active: activeElement === index}" v-on:setActive="activeElement = index" />
				</div>
			</Swiper>
		</div>
		<div class="config-block__wrap mt-48" v-if="(radio1[selectedLatchValue].label==='Под цилиндр')">
			<div class="config-block__wrap-title">Модель защелки</div>
			<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
				<div class="swiper-slide" v-for="(slide, index) of latchCilinder">
					<SimpleItem :image="slide.image" :price="slide.price" :priceType="2" :key="index"
						:class="{active: activeElement === index}" v-on:setActive="setActiveLatch(index)" />
				</div>
			</Swiper>
		</div>
		<!--<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Врезка под замок</div>
			<RadioGroup :options="radio2" :selected="radio2[1].value" name="vrezka_zamok"
				v-on:selectedValue="selectedLatchVrezka" />
		</div>-->
		<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Необходимость завертки</div>
			<RadioGroup :options="radio3" :selected="radio3[1].value" name="need_wrapping"
				v-on:selectedValue="selectedLatchZavertka" />
		</div>
		<div class="config-block__wrap mt-48" v-if="selectedLatchZavertkaValue !== 0">
			<div class="config-block__wrap-title">Модели заверток</div>
			<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
				<div class="swiper-slide" v-for="(slide, index) of step8.zavertka">
					<SimpleItem :image="slide.image" :price="slide.price" :priceType="2" :key="index"
						:class="{active: activeElement2 === index}" v-on:setActive="activeElement2 = index" />
				</div>
			</Swiper>
		</div>
	</div>
	<div v-else>
		<div class="config-block__wrap">
			<div class="config-block__wrap-title">Тип защелки</div>
			<div class="config-block__row flex">
				<PuSkeleton width="100px" height="24px" style="margin: 0 30px 0 0" />
				<PuSkeleton width="100px" height="24px" />
			</div>
		</div>
		<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Модель защелки</div>
			<Swiper :basicSlidesPerView="1.4" :basicSpaceBetween="20" :breakpointsForSlides="3">
				<div class="swiper-slide" v-for="i of [1,2,3]">
					<PuSkeleton height="180px" />
				</div>
			</Swiper>
		</div>
		<!--<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Врезка под замок</div>
			<div class="config-block__row flex">
				<PuSkeleton width="100px" height="24px" style="margin: 0 30px 0 0" />
				<PuSkeleton width="100px" height="24px" />
			</div>
		</div>
		<div class="config-block__wrap mt-48">
			<div class="config-block__wrap-title">Необходимость завертки</div>
			<div class="config-block__row flex">
				<PuSkeleton width="100px" height="24px" style="margin: 0 30px 0 0" />
				<PuSkeleton width="100px" height="24px" />
			</div>
		</div>-->
	</div>
</div>
`,
});
